import { __awaiter, __decorate } from "tslib";
import { Component } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { WebsiteThemeService } from "../../services/website-theme.service";
import { LanguageService } from "../../services/language.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { SharedHttp } from "../../services/http-client.service";
import { AuthService } from "../../services/auth.service";
import { WebClientService } from "../../services/webclient-settings.service";
let KycReassessmentComponent = class KycReassessmentComponent {
    constructor(sanitizer, themeService, languageService, formBuilder, httpClient, auth, webSettingsService) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.languageService = languageService;
        this.formBuilder = formBuilder;
        this.httpClient = httpClient;
        this.auth = auth;
        this.webSettingsService = webSettingsService;
        this.secondColor = '';
        this.errorColor = '';
        this.inputBackColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.successColor = '';
        this.inputTextColor = '';
        this.textColor = '';
        this.mainColor = '';
        this.lang = '';
        this.keyword = 'name';
        this.professions = [];
        this.professionsByLang = [];
        this.dropdownProfessionInFocus = false;
        this.professionError = false;
        this.otherProfessionError = false;
        this.allEmploymentTypes = [];
        this.allEmploymentTypesByLang = [];
        this.dropdownEmploymentTypeInFocus = false;
        this.employmentTypeError = false;
        this.countries = [];
        this.countriesDropdownInFocus = false;
        this.countryError = false;
        this.cityError = false;
        this.kycData = {};
        this.loadingSpinner = false;
        this.firstNameError = false;
        this.lastNameError = false;
        this.personalDocumentIdError = false;
        this.personalDocumentIdFormatError = false;
        this.addressLine1Error = false;
        this.step = 1;
        this.personalIdFiles = [];
        this.fileSizeError = false;
        this.confirmData = false;
        this.fileUploadMandatory = false;
        this.numberOfFilesError = false;
        this.consentExpanded = false;
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        this.webSettingsService.getSettings().subscribe((data) => {
            const size = this.webSettingsService.getCustomValue('VERIFY.ALLOWED_VERIFICATION_FILE_SIZE.VALUE');
            const parsedSize = parseInt(size);
            this.fileSize = (size !== '' && parsedSize) ? parsedSize : 0;
            const nmb = this.webSettingsService.getCustomValue('VERIFY.NUMBER_OF_VERIFICATION_FILES.VALUE');
            const parsedNumber = parseInt(nmb);
            this.numberOfFiles = (nmb !== '' && parsedNumber) ? parsedNumber : 0;
        });
        this.languageService.getChosenLanguage().subscribe((lang) => {
            var _a, _b;
            this.lang = lang ? lang : 'en';
            this.allEmploymentTypesByLang = this.allEmploymentTypes ? this.allEmploymentTypes.filter(employmentType => employmentType.lang === this.lang) : [];
            this.professionsByLang = this.professions ? this.professions.filter(profession => profession.lang === this.lang) : [];
            if (this.kycData.employmentType) {
                this.employmentTypesForm.get('employmentAutoComplete').patchValue((_a = this.allEmploymentTypesByLang.find(employmentType => employmentType.id === this.kycData.employmentType)) === null || _a === void 0 ? void 0 : _a.name);
            }
            if (this.kycData.profession) {
                this.professionsForm.get('professionsAutoComplete').patchValue((_b = this.professionsByLang.find(profession => profession.id === this.kycData.profession)) === null || _b === void 0 ? void 0 : _b.name);
            }
        });
        this.employmentTypesForm = this.formBuilder.group({
            employmentAutoComplete: ''
        });
        this.professionsForm = this.formBuilder.group({
            professionsAutoComplete: ''
        });
        this.countriesForm = this.formBuilder.group({
            countriesAutoComplete: ''
        });
    }
    ngOnInit() {
        this.kycData.firstName = this.data.user.first_name;
        this.kycData.lastName = this.data.user.last_name;
        this.kycData.personalDocumentId = this.data.user.personal_id;
        this.kycData.countryId = this.data.user.countryId;
        this.kycData.city = this.data.user.city;
        this.kycData.postCode = this.data.user.post_code;
        this.kycData.addressLine1 = this.data.user.address_line_1;
        this.kycData.addressLine2 = this.data.user.address_line_2;
        this.kycData.employmentType = this.data.user.employmentTypeId;
        this.kycData.profession = this.data.user.professionId;
        this.kycData.otherProfession = this.data.user.otherProfession;
        this.getProfessions();
        this.getEmploymentTypes();
        this.getCountries();
    }
    close() {
        this.modal.destroy();
    }
    getProfessions() {
        this.httpClient.get('user/professions').subscribe((data) => {
            var _a;
            this.professions = data;
            this.professionsByLang = this.professions ? this.professions.filter(profession => profession.lang === this.lang) : [];
            this.professionsForm.get('professionsAutoComplete').patchValue((_a = this.professionsByLang.find(profession => profession.id === this.kycData.profession)) === null || _a === void 0 ? void 0 : _a.name);
        });
    }
    setProfession(item) {
        this.kycData.profession = item.id;
        if (item.id !== -1) {
            this.kycData.otherProfession = '';
        }
    }
    checkOtherProfession() {
        this.otherProfessionError = this.kycData.profession === -1 && !this.kycData.otherProfession;
        return !this.otherProfessionError;
    }
    onFocusedProfession(e) {
        this.dropdownProfessionInFocus = e;
        this.professionError = !e && !this.kycData.profession;
        return !this.professionError;
    }
    onProfessionClear(e) {
        this.kycData.profession = null;
    }
    getEmploymentTypes() {
        this.httpClient.get('user/employmenttypes').subscribe((data) => {
            var _a;
            this.allEmploymentTypes = data;
            this.allEmploymentTypesByLang = this.allEmploymentTypes ? this.allEmploymentTypes.filter(employmentType => employmentType.lang === this.lang) : [];
            this.employmentTypesForm.get('employmentAutoComplete').patchValue((_a = this.allEmploymentTypesByLang.find(employmentType => employmentType.id === this.kycData.employmentType)) === null || _a === void 0 ? void 0 : _a.name);
        });
    }
    setEmploymentType(item) {
        this.kycData.employmentType = item.id;
    }
    onEmploymentTypeClear(e) {
        this.kycData.employmentType = null;
    }
    onFocusedEmploymentType(e) {
        this.dropdownEmploymentTypeInFocus = e;
        this.employmentTypeError = !e && !this.kycData.employmentType;
        return !this.employmentTypeError;
    }
    getCountries() {
        this.httpClient.get('user/registrationcountries').subscribe((data) => {
            this.countries = data;
            if (this.data.user.countryId) {
                this.countriesForm.get('countriesAutoComplete').setValue(this.countries.find(country => country.id === this.data.user.countryId));
            }
        });
    }
    setCountry(item) {
        this.kycData.countryId = item.id;
    }
    onFocusedCountriesDropdown(e) {
        this.countriesDropdownInFocus = e;
        this.countryError = !e && !this.kycData.countryId;
        return !this.countryError;
    }
    onCountriesDropdownClear(e) {
        this.kycData.countryId = null;
    }
    submitData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.onFocusedEmploymentType(false) || !this.onFocusedProfession(false) || !this.checkOtherProfession() || !this.confirmData ||
                (this.fileUploadMandatory && (this.personalIdFiles.length === 0 || this.personalIdFiles.length > this.numberOfFiles))) {
                return;
            }
            this.kycData.personalIdFiles = yield this.prepareFilesForUpload(this.personalIdFiles);
            this.loadingSpinner = true;
            this.httpClient.post('user/updatekycdata', this.kycData).subscribe(data => {
                this.auth.fetchUser().then(() => {
                    this.data.user = JSON.parse(localStorage.getItem('user'));
                    this.loadingSpinner = false;
                });
            });
        });
    }
    prepareFilesForUpload(files) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            const documentationFiles = [];
            const readUploadedFileAsDataURL = (file) => {
                const reader = new FileReader();
                return new Promise((resolve) => {
                    reader.onload = () => {
                        documentationFiles.push({
                            name: file.name,
                            content: reader.result
                        });
                        resolve();
                    };
                    reader.readAsDataURL(file);
                });
            };
            for (const file of files) {
                formData.append(file.name, file);
                yield readUploadedFileAsDataURL(file);
            }
            return documentationFiles;
        });
    }
    checkIfFormIsValid() {
        return !this.kycData.employmentType || this.employmentTypeError || this.kycData.profession == null || this.professionError ||
            (this.kycData.profession === -1 && !this.kycData.otherProfession || this.otherProfessionError) || this.kycData.isPep === undefined || !this.confirmData ||
            (this.fileUploadMandatory && (this.personalIdFiles.length === 0 || this.personalIdFiles.length > this.numberOfFiles));
    }
    logout() {
        this.auth.logOut(true, false);
        this.close();
    }
    checkFirstName() {
        const regex = /^[\p{L}]+(?:[-\s][\p{L}]+)*$/u;
        this.firstNameError = !this.kycData.firstName || !regex.test(this.kycData.firstName);
        return !this.firstNameError;
    }
    checkLastName() {
        const regex = /^[\p{L}]+(?:[-\s][\p{L}]+)*$/u;
        this.lastNameError = !this.kycData.lastName || !regex.test(this.kycData.lastName);
        return !this.lastNameError;
    }
    checkPersonalDocumentId() {
        const regex = /^[\p{L}0-9 -]+$/u;
        const personalDocumentId = this.kycData.personalDocumentId ? this.kycData.personalDocumentId.trim() : '';
        this.kycData.personalDocumentId = personalDocumentId;
        this.personalDocumentIdError = false;
        this.personalDocumentIdFormatError = false;
        if (!personalDocumentId) {
            this.personalDocumentIdError = true;
        }
        else if (personalDocumentId !== this.getOriginalPersonalDocumentId() &&
            (personalDocumentId.length >= 13 || !regex.test(personalDocumentId))) {
            this.personalDocumentIdFormatError = true;
        }
        return !this.personalDocumentIdError && !this.personalDocumentIdFormatError;
    }
    getOriginalPersonalDocumentId() {
        return (this.data.user.personal_id || '').trim();
    }
    checkCity() {
        this.cityError = !this.kycData.city;
        return !this.cityError;
    }
    checkAddressLine1() {
        this.addressLine1Error = !this.kycData.addressLine1;
        return !this.addressLine1Error;
    }
    checkIfStep1FormIsInvalid() {
        return !this.kycData.firstName || this.firstNameError || !this.kycData.lastName || this.lastNameError ||
            !this.kycData.personalDocumentId || this.personalDocumentIdError || this.personalDocumentIdFormatError ||
            !this.kycData.countryId || !this.kycData.city || !this.kycData.addressLine1;
    }
    goToNextScreen() {
        if (!this.checkFirstName() || !this.checkLastName() || !this.checkPersonalDocumentId() || !this.onFocusedCountriesDropdown(false) ||
            !this.checkCity() || !this.checkAddressLine1()) {
            return;
        }
        if (this.data.user.kyc_reassessment_documents_resubmission_required || this.kycData.firstName !== this.data.user.first_name ||
            this.kycData.lastName !== this.data.user.last_name || this.kycData.personalDocumentId !== this.getOriginalPersonalDocumentId() ||
            this.kycData.countryId !== this.data.user.countryId || this.kycData.city !== this.data.user.city ||
            this.kycData.postCode !== this.data.user.post_code || this.kycData.addressLine1 !== this.data.user.address_line_1 ||
            this.kycData.addressLine2 !== this.data.user.address_line_2) {
            this.fileUploadMandatory = true;
        }
        else {
            this.fileUploadMandatory = false;
        }
        this.step++;
    }
    fileChange(event) {
        const input = event.target;
        const selected = this.toArray(input.files);
        this.fileSizeError = false;
        this.numberOfFilesError = false;
        if (this.numberOfFiles > 0 && this.personalIdFiles.length + selected.length > this.numberOfFiles) {
            this.numberOfFilesError = true;
            input.value = '';
            return;
        }
        const validFiles = [];
        for (const file of selected) {
            const ext = (file.name.split('.').pop() || '').toLowerCase();
            const allowed = this.checkFileExtension(ext);
            if (file.size > 1024 * 1024 * this.fileSize || !allowed) {
                this.fileSizeError = true;
                continue;
            }
            validFiles.push(file);
        }
        if (validFiles.length > 0) {
            this.personalIdFiles = this.personalIdFiles.concat(validFiles);
        }
        input.value = '';
    }
    removeFile(fileIndex) {
        const list = this.personalIdFiles.slice();
        list.splice(fileIndex, 1);
        this.personalIdFiles = list;
    }
    toArray(fileList) {
        return fileList ? Array.prototype.slice.call(fileList) : [];
    }
    checkFileExtension(extLower) {
        const allowed = ['jpg', 'png', 'jpeg', 'pdf', 'gif'];
        return allowed.includes(extLower);
    }
    goBack() {
        this.step = 1;
    }
    showMoreConsent() {
        this.consentExpanded = true;
    }
};
KycReassessmentComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: LanguageService },
    { type: FormBuilder },
    { type: SharedHttp },
    { type: AuthService },
    { type: WebClientService }
];
KycReassessmentComponent = __decorate([
    Component({
        selector: 'ecd-kyc-reassessment',
        template: __importDefault(require("./kyc-reassessment.component.html")).default,
    })
], KycReassessmentComponent);
export { KycReassessmentComponent };
